import { saveClicked, saveVisited } from './links.js'

document.addEventListener('DOMContentLoaded', () => {
  saveClicked()
  saveVisited()

  const swiperSample = setSwiperSample();

  if(window.matchMedia('(max-width: 768px)').matches){
    const swiperCKA = setSwiperCKA();
  }

  const uwb = new UWB({
    uaTabletViewport: {
      init: true,
      width: 1140,
    },
    toolFixedHorizontalScroll: false,
  });
});

const setSwiperSample = () => {
  return new Swiper('.sliderSample', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    direction: 'horizontal',
    centeredSlides : true,
    autoplay: {
      delay: 10000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}

const setSwiperCKA = () => {
  return new Swiper('.sliderCKA', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides : true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}
